import React from 'react'
import StudentData from '../StudentData/StudentData'
import LcsData from './LcsData'

const LearningGrowth = () => {
  return (
    <div className='flex gap-2'>
      <StudentData type="learning-growth" />
      <LcsData />
    </div>
  )
}

export default LearningGrowth